import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
const guarantees = ['Acceso inmediato', 'Para docentes de Hispanoamérica', 'Pago seguro'];
export function Hero() {
  return <header className="w-full bg-cream-100 px-6 pb-10 pt-5 sm:pt-7" data-id="element-85" data-mp="4m8lmajdinjv">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-86" data-mp="4jvyzk2o7p0h">
        <span className="rounded-full bg-cream-200 px-5 py-1.5 text-xs font-semibold tracking-[0.22em] text-forest-700" data-id="element-87" data-mp="127ef5fynvtei">
          KIT INSTRUMENTACIÓN INDUSTRIAL 2026
        </span>

        <h1 className="mt-4 font-display text-4xl font-bold leading-[1.02] text-forest-800 sm:text-6xl lg:text-7xl" data-id="element-88" data-mp="s9q8psrp0xgi">
          Del Sensor al Aula.
          <span className="block text-ember-500" data-id="element-89" data-mp="3d1a99mbhsfec">Todo resuelto.</span>
        </h1>

        <img src={HERO_IMAGE} alt="Los 6 volúmenes del Kit Instrumentación Industrial 2026 junto a los 5 bonos, material imprimible y recursos digitales" className="-my-4 w-full max-w-xl sm:-my-6" data-id="element-90" data-mp="3cz5wsfzj282g" />

        <p className="max-w-2xl text-base leading-relaxed text-forest-700/75 sm:text-lg" data-id="element-91" data-mp="3o7vl7nivvtyv">
          Kit Instrumentación Industrial con 6 volúmenes técnicos, 5 bonos estratégicos e implementación
          docente 360°.
        </p>

        <ul className="mt-4 flex flex-col items-center gap-1.5 text-sm text-forest-600 sm:flex-row sm:gap-7 sm:text-base" data-id="element-92" data-mp="3e7l59v5gs8g0">
          {guarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-93" data-mp="358zpg7rdn7ix">
              <CheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-94" data-mp="2qjv80ssep7bv" />
              {item}
            </li>)}
        </ul>

        <CtaButton className="mt-6" source="hero" data-id="element-95" data-mp="2vjzpal152635" />

        <div className="mt-4 flex flex-col items-center gap-2 text-sm text-forest-700/70 sm:flex-row sm:gap-5" data-id="element-96" data-mp="2hj5exwuj5v1u">
          <span className="flex items-center gap-2" data-id="element-97" data-mp="2lkike5tpnw88">
            <span className="flex" aria-hidden="true" data-id="element-98" data-mp="2lk8qw89gj6xs">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-99" data-mp="s3ck463mvbog" />)}
            </span>
            4.9/5 — +150 docentes
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-100" data-mp="id9v0gzmuhve" />
          <span className="flex items-center gap-2" data-id="element-101" data-mp="ddww2xvhlkcg">
            <ShieldCheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-102" data-mp="db2ede3uydmq" />
            Garantía 7 Días
          </span>
          <span className="hidden h-4 w-px bg-cream-300 sm:block" aria-hidden="true" data-id="element-103" data-mp="1622jxthu7pgi" />
          <span className="flex items-center gap-2" data-id="element-104" data-mp="112pud0zl04a8">
            <CreditCardIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-105" data-mp="11151dfsx0teh" />
            Tarjeta · Mercado Pago
          </span>
        </div>
      </div>
    </header>;
}